module.exports = __webpack_public_path__ + "static/media/Volvo_iron_mark_RGB_140x140px-logo@2.13824acc.png";